import type { BoxProps } from '@/ui';
import { Box } from '@/ui';
import type { FC, PropsWithChildren } from 'react';

export const ArticleContentBox: FC<PropsWithChildren<BoxProps>> = (props) => (
  <Box maxWidth={720} margin="auto" {...props} />
);
